<app-generic-container>
  <!-- Usamos el panel genérico -->
  <app-generic-panel [title]="panelTitle" [description]="" [awesomeIcon]="panelIcon">
    <form class="form-horizontal" (ngSubmit)="onSubmit(formEmpleado)" #formEmpleado="ngForm" novalidate>
      <dx-load-panel #loadPanel shadingColor="rgba(231, 231, 231,0.4)"
        [visible]="loading" [showIndicator]="true" [showPane]="true" [shading]="true" [closeOnOutsideClick]="false">
    </dx-load-panel>
      <div class="row">
        <div class="col-12">
          <app-company-selector dataSize="7" placeHolder="Empresa" [(ngModel)]="selectedCompany" name="selectedCompany"
            [gestionEmpleados]="true" [onlyConfigured]="true" [required]="true"
            [disabled]="model && !model.isNew || !isNew" (ngModelChange)="onCompanyChange($event)" [tabIndex]="1">
          </app-company-selector>
        </div>
      </div>

      <legend>Datos Personales</legend>

      <div class="row">
        <div class="col-sm-12 col-lg-12">
          <div class="row">

            <div class="col-4" *ngIf="isNew">
              <mat-form-field>
                <mat-select placeholder="Tipo de identificación" name="tipoDocumento" [(ngModel)]="tipoDocumento"
                  [disabled]="!selectedCompany || !isNew" tabIndex="2" [required]="isNew" (selectionChange)="onTipoDocumentoChange($event)">
                  <mat-option *ngFor="let tipoDocumento of identificationTypes" [value]="tipoDocumento.id">{{
                    tipoDocumento.description }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field>
                <input matInput type="text" name="nif" placeholder="Número de identificación" required tabIndex="3" 
                  minlength="9" maxlength="9" (blur)="onNifBlur(nif)" [(ngModel)]="nif" (input)="onInputIdentification($event)"
                  [disabled]="!selectedCompany || !isNew" #NumeroIdentificacion="ngModel" />
                <mat-error *ngIf="(!nifValido)">
                  El documento indicado no tiene el formato correcto.
                </mat-error>
                <mat-error *ngIf="(empleadoExiste)">
                  Ya existe un empleado con ese documento de identificación.
                </mat-error>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field>
                <input matInput type="text" name="numAfiliacion" placeholder="Nº Afiliación SS"
                  pattern="^(\d{2})\/(\d{8})\/(\d{2})$" minlength="14" maxlength="14" [(ngModel)]="numAfiliacion"
                  required tabIndex="4" [disabled]="!selectedCompany || !isNew" #numeroAfiliacion="ngModel" (input)="onNumAfiliacionInput($event)" />
                <mat-hint *ngIf="!numeroAfiliacion.errors?.pattern && isNew">XX/YYYYYYYY/ZZ</mat-hint>
                <mat-error *ngIf="numeroAfiliacion.invalid && numeroAfiliacion.errors?.pattern">
                  El Nº Afiliación SS no tiene un formato válido: XX/YYYYYYYY/ZZ.
                </mat-error>
              </mat-form-field>
            </div>

          </div>

          <div class="row">

            <div class="col-4">
              <mat-form-field>
                <input matInput type="text" name="nombre" placeholder="Nombre" [(ngModel)]="nombre" tabIndex="5"
                  required [disabled]="!selectedCompany || !isNew" />
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field>
                <input matInput type="text" name="apellido1" placeholder="Primer apellido" [(ngModel)]="apellido1"
                  tabIndex="6" required [disabled]="!selectedCompany || !isNew" />
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field>
                <input matInput type="text" name="apellido2" placeholder="Segundo apellido" [(ngModel)]="apellido2"
                  tabIndex="7" [disabled]="!selectedCompany || !isNew" />
              </mat-form-field>
            </div>

          </div>
          <div class="row">
            <div class="col-4">
              <mat-form-field>
                <mat-select placeholder="Sexo" name="sexo" [(ngModel)]="sexo" [disabled]="!selectedCompany || !isNew"
                  tabIndex="8" required>
                  <mat-option *ngFor="let sexo of sexTypes" [value]="sexo.id">{{ sexo.description }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-4">
              <mat-form-field *ngIf="isNew">
                <input matInput type="text" name="calle" placeholder="Calle" [(ngModel)]="calle"
                  [disabled]="!selectedCompany" tabIndex="9" required maxlength="40" />
                <mat-hint>{{ calle?.length || 0 }} / 40</mat-hint>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <legend>Datos Laborales</legend>

      <div class="row">
        <div class="col-sm-12 col-lg-4">
          <div class="row">
            <div class="col-12">
              <app-mat-select-filtered [items]="centros" [valueColumn]="'workplaceCode'"
                [descriptionColumns]="['workplaceName']" [(ngModel)]="centro"
                [placeHolder]="'Centro'" name="centro" [disabled]="!selectedCompany || !isNew" required [tabIndex]="10">
              </app-mat-select-filtered>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <app-mat-select-filtered *ngIf="isNew" [items]="jobPositions" [valueColumn]="'jobCode'"
                [descriptionColumns]="['jobDescription']" [(ngModel)]="jobPosition"
                [placeHolder]="'Puesto de trabajo'" name="jobPosition" [disabled]="!selectedCompany" required
                [tabIndex]="13">
              </app-mat-select-filtered>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <app-mat-select-filtered *ngIf="isNew" [items]="tariffGroups" [valueColumn]="'contributionGroupID'"
                [descriptionColumns]="['contributionGroupID', 'description']" [(ngModel)]="tariffGroup"
                [placeHolder]="'Grupo de tarifa'" name="tariffGroup" [disabled]="!selectedCompany" required
                [tabIndex]="16">
              </app-mat-select-filtered>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-lg-4">
          <div class="row">
            <div class="col-12">
              <app-mat-select-filtered [items]="personTypes" [valueColumn]="'id'"
                [descriptionColumns]="['description']" [(ngModel)]="tipoTrabajador"
                [placeHolder]="'Tipo de trabajador'" name="tipoTrabajador" [disabled]="!selectedCompany || !isNew" required
                [tabIndex]="11">
              </app-mat-select-filtered>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <app-mat-select-filtered *ngIf="isNew" [items]="contributionTypes" [valueColumn]="'id'"
                [descriptionColumns]="['description']" [(ngModel)]="contributionType"
                [placeHolder]="'Tipo de cotización'" name="contributionType" [disabled]="!selectedCompany" required
                [tabIndex]="14">
              </app-mat-select-filtered>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <mat-form-field *ngIf="isNew">
                <input matInput [matDatepicker]="pickerFechaAlta" [(ngModel)]="fechaAlta" name="fechaAlta" tabIndex="17"
                  placeholder="Fecha de alta" [disabled]="!selectedCompany" required (input)="onDateInput($event)"
                  [matDatepickerFilter]="validarFecha" />
                <mat-datepicker-toggle matSuffix [for]="pickerFechaAlta"></mat-datepicker-toggle>
                <mat-datepicker #pickerFechaAlta></mat-datepicker>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-sm-12 col-lg-4">
          <div class="row">
            <div class="col-12">
              <app-mat-select-filtered [items]="companyAgreements" [valueColumn]="'agreementCode'" *ngIf="isNew"
              [descriptionColumns]="['description']" [(ngModel)]="companyAgreement"
              [placeHolder]="'Convenio de empresa'" name="companyAgreement" [disabled]="!selectedCompany" required
              [tabIndex]="12">
            </app-mat-select-filtered>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <app-mat-select-filtered  *ngIf="isNew" [items]="regimes" [valueColumn]="'regimeID'"
                [descriptionColumns]="['description']" [(ngModel)]="regime"
                [placeHolder]="'Tipo de régimen'" name="regime" [disabled]="!selectedCompany" required
                [tabIndex]="15">
              </app-mat-select-filtered>
            </div>
          </div>
        </div>
      </div>

      <!-- Botonera -->
      <div class="row">
        <label class="col-md-3"></label>
        <div class="col-md-9">
          <div class="form-group form-button">
            <button class="btn btn-fill btn-primary float-right" type="submit"
              [disabled]="!formEmpleado.valid || loading || !nifValido || !isNew || !fechaValida" tabindex="18">Guardar</button>
            <a class="btn btn-fill btn-outline-white float-right" routerLink="../">Volver</a>
          </div>
        </div>
      </div>
    </form>


  </app-generic-panel>
</app-generic-container>
